import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

const PageHeaderContext = createContext();

export function PageHeaderProvider({ children }) {
  const [headerConfig, setHeaderConfig] = useState({
    title: null,
    subtitle: null,
    backButton: null,
    actions: [],
  });

  const resetHeaderConfig = useCallback(() => {
    setHeaderConfig({
      title: null,
      subtitle: null,
      backButton: null,
      actions: [],
    });
  }, []);

  // Memoize context value to prevent infinite re-render loops
  // Only recreate when headerConfig/functions actually change
  const contextValue = useMemo(
    () => ({ headerConfig, setHeaderConfig, resetHeaderConfig }),
    [headerConfig, resetHeaderConfig]
  );

  return (
    <PageHeaderContext.Provider value={contextValue}>
      {children}
    </PageHeaderContext.Provider>
  );
}

export function usePageHeader() {
  const context = useContext(PageHeaderContext);
  if (!context) {
    throw new Error('usePageHeader must be used within PageHeaderProvider');
  }
  return context;
}
